module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/result01_sp-c1bfa0b8d0e6fbd2c4c219ecf5f9de81.png";